import { createContext, useContext, useEffect, useRef, useState } from "react";
import { WS_URL } from "./client";

import io from "socket.io-client";
import { useDispatch, useSelector } from "react-redux";
import { chatSlicer } from "../redux/slicers/chatSlicer";
import { currentProfileSlicer } from "../redux/slicers/currentProfileSlicer";
import { markAsRead } from "../redux/actions/chatActions";

const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
  // const socket = useRef();
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const socketInstance = io(WS_URL);
    // socket = socketInstance;
    setSocket(socketInstance);
    // socket.current = socketInstance;

    return () => {
      socketInstance.disconnect();
    };
  }, []);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};

export const useSocket = () => {
  const socket = useContext(SocketContext);

  if (socket === undefined) {
    throw new Error("useSocket must be used within a SocketProvider");
  }

  return socket;
};

export const useSocketSubscribers = () => {
  const socket = useSocket();

  const chatState = useSelector((state) => state.chat);
  const { activeChat } = chatState;
  const currentProfile = useSelector((state) => state.currentProfile.data);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!socket) return;
    if (currentProfile) {
      socket.emit("setup", currentProfile);
    }
  }, [currentProfile]);

  useEffect(() => {
    socket.on("message received", (newMessageReceived) => {
      const chatId = newMessageReceived.chatId._id;

      if (activeChat !== chatId) {
        dispatch(chatSlicer.actions.increaseUnread({ chatId }));
      } else {
        dispatch(chatSlicer.actions.addMessage(newMessageReceived));
        dispatch(markAsRead(chatId));
      }
    });

    socket.on("new notification", (notification) => {
      dispatch(currentProfileSlicer.actions.addNotification(notification));
    });

    return () => {
      socket.off("message received");
      socket.off("new notification");
    };
  }, [dispatch, activeChat]);
};

